import { useState, useMemo } from 'react';

import { ModelTable, Button } from '@component';
import { useServices } from '@services';

import { collection } from './constants';
import { Item } from './Item';

export const CarcaseSubcategoryList = ({ className }) => {
  const [item, setItem] = useState(null);
  const [updatedOn, setUpdatedOn] = useState(new Date());
  const { db } = useServices();

  const columns = useMemo(
    () => [
      { Header: 'Name', accessor: 'name' },
      { Header: 'Category', accessor: 'category' },
    ],
    []
  );

  const newItem = {
    name: '',
    category: '',
  };

  return (
    <div className={className}>
      <div className="flex justify-between">
        <h3 className="text-lg font-bold text-black">Carcase Subcategory</h3>
        <Button onClick={() => setItem(newItem)}>Add Carcase Subcategory</Button>
      </div>
      <ModelTable
        model={{ name: 'Carcase Subcategory' }}
        collection={collection}
        columns={columns}
        version={updatedOn}
        onViewRow={row => setItem({ ...newItem, ...row })}
        className="mt-4"
        defaultSortBy={[{ id: 'name' }]}
        query={() => db.collection(collection).orderBy('name')}
      />
      <Item item={item} close={() => setItem(null)} saved={() => setUpdatedOn(new Date())}></Item>
    </div>
  );
};
